import { createUseCase } from '~core/usecase/createUseCase';
import { getPersonalizedProducts as getPersonalizedProductsQuery } from '~graphql/queries';
import {
  changedOffset,
  changedPage,
  recievedProducts,
  selectProductListState,
} from '~redux/search/product';
import { ProductReadModel } from '~types/api';
import { executeQuery } from '~utils/graphql';
import { warn } from '~utils/log';
import { getFlag } from '~view/contexts/FlagsContext';

export const getPersonalizedProducts = createUseCase(
  'search/product/getPersonalizedProducts',
  async (
    {
      accountId,
      listId,
      products,
    }: { accountId: string; listId: string; products: ProductReadModel[] },
    { dispatch }
  ) => {
    try {
      const flag = getFlag<'personalize' | 'hybrid'>(
        'productListSort',
        'personalize'
      );
      const res = await executeQuery(getPersonalizedProductsQuery, {
        userId: accountId,
        itemIds: products.map((product) => product.id!),
        personalizeRate: flag === 'hybrid' ? 50 : undefined,
      });
      const itemIds = (res.data?.getPersonalizedProducts ?? []) as string[];
      if (itemIds.length !== products.length) {
        throw new Error();
      }
      dispatch(
        recievedProducts({
          listId,
          products: itemIds.map(
            (itemId: string) =>
              products.find((product) => product.id === itemId)!
          ),
        })
      );
    } catch (e: any) {
      warn(e);
      dispatch(
        recievedProducts({
          listId,
          products,
        })
      );
    }
  }
);

const MAX_OFFSET = 500;
export const paginate = createUseCase(
  'search/product/paginate',
  async (
    { listId, page }: { listId: string; page: number },
    { dispatch, getState }
  ) => {
    const state = getState();
    const listState = selectProductListState(state, listId);
    if (!listState) {
      return;
    }
    let offset = 0;
    for (let i = 1; i <= page; i++) {
      const length = listState.itemsPerPage * i;
      if (length > offset + MAX_OFFSET) {
        offset = (i - 1) * listState.itemsPerPage - 1;
      }
    }
    if (offset != listState.offset) {
      dispatch(changedOffset({ listId, offset }));
    }
    dispatch(changedPage({ listId, page }));
  }
);
